import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import WebOutlinedIcon from '@mui/icons-material/WebOutlined';
import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import StoreOutlinedIcon from '@mui/icons-material/StoreOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import DataObjectOutlinedIcon from '@mui/icons-material/DataObjectOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import HubOutlinedIcon from '@mui/icons-material/HubOutlined';
import QuizOutlinedIcon from '@mui/icons-material/QuizOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import FamilyRestroomOutlinedIcon from '@mui/icons-material/FamilyRestroomOutlined';
import PersonPinOutlinedIcon from '@mui/icons-material/PersonPinOutlined';
import AutoStoriesOutlinedIcon from '@mui/icons-material/AutoStoriesOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LocalLibraryOutlinedIcon from '@mui/icons-material/LocalLibraryOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import QueueOutlinedIcon from '@mui/icons-material/QueueOutlined';

const MENU_ICONS = {
  add: AddCircleOutlineIcon,
  dashboard: DashboardOutlinedIcon,
  campaign: CampaignOutlinedIcon,
  checklist: ChecklistOutlinedIcon,
  settings: SettingsOutlinedIcon,
  map: MapOutlinedIcon,
  people: PeopleOutlinedIcon,
  web: WebOutlinedIcon,
  message: MessageOutlinedIcon,
  store: StoreOutlinedIcon,
  assessment: AssessmentOutlinedIcon,
  analytics: BarChartOutlinedIcon,
  intervene: ChatBubbleOutlineIcon,
  accountTree: AccountTreeOutlinedIcon,
  howToReg: HowToRegOutlinedIcon,
  dataObject: DataObjectOutlinedIcon,
  smartToy: SmartToyOutlinedIcon,
  whatsapp: WhatsAppIcon,
  hub: HubOutlinedIcon,
  quiz: QuizOutlinedIcon,
  school: SchoolOutlinedIcon,
  familyRestroom: FamilyRestroomOutlinedIcon,
  personPin: PersonPinOutlinedIcon,
  autoStories: AutoStoriesOutlinedIcon,
  timeline: TimelineOutlinedIcon,
  infoOutlined: InfoOutlinedIcon,
  localLibrary: LocalLibraryOutlinedIcon,
  autoAwesome: AutoAwesomeOutlinedIcon,
  menuBook: MenuBookOutlinedIcon,
  logout: LogoutIcon,
  person: PersonOutlinedIcon,
  history: HistoryOutlinedIcon,
  login: LoginOutlinedIcon,
  lock: LockOutlinedIcon,
  accountCircle: AccountCircleOutlinedIcon,
  queue: QueueOutlinedIcon,
};

/**
 * @param {string} [iconKey]
 * @returns {import('react').ElementType|null}
 */
export function getMenuIcon(iconKey) {
  if (!iconKey) return null;
  return MENU_ICONS[iconKey] || null;
}

export default MENU_ICONS;
